function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m344.75 28.55v61.49h-177.5v-61.49h-104.25v483.45h261.29v-124.71h124.71v-358.74zm-88.7 234.45c33.91 0 61.5 25.02 61.5 55.77 0 26.06-19.82 47.99-46.5 54.08v23.15h-30v-23.15c-26.68-6.09-46.5-28.02-46.5-54.08h30c0 14.2 14.13 25.76 31.5 25.76s31.5-11.56 31.5-25.76c0-14.21-14.13-25.77-31.5-25.77-33.91 0-61.5-25.02-61.5-55.77 0-26.06 19.82-47.99 46.5-54.08v-23.15h30v23.15c26.68 6.09 46.5 28.02 46.5 54.08h-30c0-14.2-14.13-25.76-31.5-25.76s-31.5 11.56-31.5 25.76c0 14.21 14.13 25.77 31.5 25.77zm98.24 249 94.71-94.71h-94.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m197.25 0v28.55 31.49h117.5v-31.49-28.55z"
}));

var SvgPricingPlanIcon = function SvgPricingPlanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPricingPlanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PricingPlanIcon.044e34f3.svg";
export { ForwardRef as ReactComponent };